import { AUTH0_ELEPHANT_CLAIM_NAMESPACE } from "$global-providers/user-provider/provider";
import { useAuth0 } from "@auth0/auth0-react";
import { useCallback, useMemo, useState } from "react";
import { EpocusClaimRefreshContext } from "./epocus-claim-refresh";

export const EpocusClaimProvider: FCwC = ({ children }) => {
  const { getAccessTokenSilently, getIdTokenClaims } = useAuth0();
  const [refreshed, setRefreshed] = useState<unknown>(undefined);

  const refresh = useCallback(async () => {
    await getAccessTokenSilently({ ignoreCache: true });
    const claims = await getIdTokenClaims();
    setRefreshed(claims?.[AUTH0_ELEPHANT_CLAIM_NAMESPACE]?.epocus ?? null);
  }, [getAccessTokenSilently, getIdTokenClaims]);

  const value = useMemo(() => ({ refreshed, refresh }), [refreshed, refresh]);

  return (
    <EpocusClaimRefreshContext.Provider value={value}>
      {children}
    </EpocusClaimRefreshContext.Provider>
  );
};
